import { useMutation } from "@apollo/client";
import { UPDATE_INSTRUCTOR_ASSIGNATION_TYPE } from "./graphql/updateInstructorAssignationType.mutation";
import {
  UpdateInstructorAssignationTypePayload,
  UpdateInstructorAssignationTypeProps,
} from "@services/types/instructor/instructorTypes";

export const useUpdateInstructorAssignationType = (
  props?: UpdateInstructorAssignationTypeProps,
) => {
  const [updateInstructorAssignationTypeMutation, { loading }] = useMutation(
    UPDATE_INSTRUCTOR_ASSIGNATION_TYPE,
  );

  const updateInstructorAssignationType = async ({
    scenarioId,
    originId,
    changesets,
  }: UpdateInstructorAssignationTypePayload) => {
    try {
      const { data } = await updateInstructorAssignationTypeMutation({
        variables: {
          scenarioId,
          originId,
          input: {
            changesets,
          },
        },
      });

      if (data?.cube?.updateAssignationType?.commited) {
        props?.onSuccess?.();
        return true;
      }
      return false;
    } catch (error) {
      console.error("Error updating instructor assignation type:", error);
      return false;
    }
  };

  return {
    isLoading: loading,
    updateInstructorAssignationType,
  };
};
